export default "* Dyrespor\n* Fodspor\n* Æde\n* Lort\n* Bolig (rede, sæde, hule, grav osv.)\n";